export default __webpack_public_path__ + "static/media/179.2b2dd534.png";